import { DropdownPaginated } from 'components/commons';
import React, { useCallback } from 'react';
import { useApi } from 'hooks';
import { getProducts } from 'apis/product.api';

const SelectProduct = ({ placeholder = '', hasAll = false, searchKey, ...props }) => {
  const {
    request,
    loading,
    result = { products: [], count: 0 }
  } = useApi({
    api: getProducts,
    pageError: true
  });

  const fetch = useCallback(
    async (params) => {
      return await request({
        perPage: 10,
        ...params
      });
    },
    [request]
  );

  let otherOptions;
  if (hasAll) {
    otherOptions = { allOption: [{ label: 'All', value: null }] };
  }

  return (
    <DropdownPaginated
      {...props}
      request={async (params) => {
        if (searchKey) {
          params.searchKey = searchKey;
        }

        return await fetch(params);
      }}
      total={result.count}
      loading={loading}
      formatRequest={(result) => {
        const { products = [] } = result || {};
        if (products && products.length > 0) {
          const newCategories = products;

          return newCategories.map((d) => {
            return {
              label: d.name,
              value: d.productId
            };
          });
        }
        return [];
      }}
      placeholder={placeholder}
      {...otherOptions}
    />
  );
};

export default SelectProduct;
